import { API_METHOD, BASE_URL, HOST_URL, REQUEST_URL } from "../constants/constants"
import { interceptor } from "../interceptor/interceptor"

export const revokeUser = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl + REQUEST_URL.revokeEmployee ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const unRevokeUser = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl + REQUEST_URL.unRevokeEmployee ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}


export const revokeMultipleUser = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl + REQUEST_URL.revokedMultipleEmployee ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const unRevokeMultipleUser = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.allocateEmployees ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const registerEmployee = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl + REQUEST_URL.registerEmployee ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const updateEmployee = async(body, query) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.put,
        url:HOST_URL.url + BASE_URL.employeeUrl + REQUEST_URL.editEmployee + `/${query}`,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}



export const getUploadCVS = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.employees ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'

    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const dd = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.employees ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'

    })
    return response
    }
    catch(error){
        console.log(error)
    }
}